import { __extends } from "tslib";
import PropType from './prop-type.class';
var String = /*@__PURE__*/ (function (_super) {
    __extends(String, _super);
    function String() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    String.validate = function (value) {
        return true;
    };
    String.parseValue = function (value) {
        return value;
    };
    return String;
}(PropType));
export default String;



//////////////////
// WEBPACK FOOTER
// ./app/bundles/enterprise-shop/src/shop-builder/core/prop-types/string.ts
// module id = null
// module chunks = 